
import { mapGetters } from 'vuex'
import coinbasePay from '~/services/coinbase-pay';

export default {
  name: 'ModalWalletBalances',

  props: {
    isFull: {type: Boolean, default: false},
    ethInsufficient: {type: Boolean, default: false},
    usdcInsufficient: {type: Boolean, default: false},
  },

  computed: {
    ...mapGetters('wallet', ['usdcBalance', 'ethBalance']),

    account() {
      return this.$store.getters.walletAddress;
    },

    ethInsufficientBalance() {
      return this.ethInsufficient || this.ethBalance === 0;
    },

    usdcInsufficientBalance() {
      return this.usdcInsufficient || this.usdcBalance === 0;
    },
  },

  mounted() {
    this.$store.dispatch('wallet/updateBalances');
  },

  methods: {
    openRamp() {
      coinbasePay(this.account, 'buy');
    },
  },
}
